import * as React from 'react';
import { FeatureFlagNames } from '@utils/bvt-feature-flags';
import withBvtFlagChecker from '@utils/bvt-feature-flags/hoc/with-bvt-flags-checker';
import OrderDetailsNew from '../pages/order-details-new';

const OrderDetailsWrapper = withBvtFlagChecker(
    OrderDetailsNew, // New page if flag is ON
    () => <React.Fragment />,
    { bvtFlagName: FeatureFlagNames.tedig3296UpliftedOrderDetails }
);

export default OrderDetailsWrapper;
